import { useTranslation } from "react-i18next";
import { Reveal } from "./Reveal";

const CAMERA_IMG =
  "https://images.unsplash.com/photo-1660917794493-53c259447182?fm=jpg&q=80&w=1600&auto=format&fit=crop";

export const Manifesto = () => {
  const { t } = useTranslation();
  const chapters = t("manifesto.chapters", { returnObjects: true });

  return (
    <section id="manifesto" className="relative bg-[#F9F8F6] px-6 py-28 text-[#1A1A1A] lg:px-12 lg:py-40" data-testid="manifesto-section">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="font-code text-[11px] uppercase tracking-[0.35em] text-[#8C3D2B]">Manifesto</p>
              <h2 className="mt-4 font-display text-4xl font-light leading-tight sm:text-5xl lg:text-6xl">
                {t("manifesto.h2pre")} <em className="italic text-[#8C3D2B]">{t("manifesto.h2em")}</em>{t("manifesto.h2post")}
              </h2>
            </Reveal>
            <Reveal delay={0.15} className="mt-12">
              <div className="relative overflow-hidden" style={{ clipPath: "polygon(0 0, 100% 6%, 100% 100%, 0 94%)" }}>
                <img src={CAMERA_IMG} alt={t("manifesto.imgAlt")} loading="lazy" decoding="async" className="aspect-[4/3] w-full object-cover" data-testid="manifesto-image" />
              </div>
              <p className="mt-4 font-code text-[10px] uppercase tracking-[0.3em] text-[#666]">{t("manifesto.caption")}</p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            {chapters.map((c, i) => (
              <Reveal key={c.title} delay={i * 0.1}>
                <div className="border-t border-[#1A1A1A]/10 py-10 first:border-t-0 first:pt-0 lg:py-12" data-testid={`manifesto-chapter-0${i + 1}`}>
                  <div className="flex items-start gap-8">
                    <span className="font-display text-6xl font-light italic leading-none text-[#8C3D2B]/30 md:text-7xl">0{i + 1}</span>
                    <div>
                      <h3 className="font-display text-2xl font-light leading-snug md:text-4xl">{c.title}</h3>
                      <p className="mt-4 max-w-lg text-sm leading-relaxed text-[#666] md:text-base">{c.body}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
